import { atom, useAtomValue } from 'jotai';

import { UserDetailsWithPermissionDto } from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';

export const UserDefaultValues: UserContextProps = {
  dataReady: false,
  email: '',
  enabled: false,
  externalUserId: '',
  firstName: '',
  lastLogin: '',
  lastName: '',
  permissions: [],
  role: undefined,
  userId: '',
  userSelectOption: { label: '', value: '' },
};

export type UserContextProps = UserDetailsWithPermissionDto & {
  dataReady: boolean;
  userSelectOption: SelectSearchOptionModel;
};

export const userAtom = atom<UserContextProps>(UserDefaultValues);

export const toUserContext = (user: UserDetailsWithPermissionDto): UserContextProps => ({
  ...user,
  dataReady: true,
  userSelectOption: {
    label: `${user.lastName} ${user.firstName}`,
    value: user.userId,
  },
});

export const useUserContext = (): UserContextProps => {
  return useAtomValue<UserContextProps>(userAtom);
};
